import axiosInstance from "utils/AxiosInterceptor";

import {
  DetailAnswer,
  RefreshPromptRequest,
  SendMessageRequest,
  ShareAnswerRequest,
  UpdateAnswerRequest,
} from "interfaces";
import { PinAnswerRequest } from "interfaces/Request/PinAnswerRequest";

export const getDetailPinnedAnswer = async (answerId: string) => {
  return axiosInstance.get<DetailAnswer>(
    `api/projects/pinned-answer-detail?answerId=${answerId}`
  );
};

export const updateAnswerDetail = (payload: UpdateAnswerRequest) => {
  return axiosInstance.put(`api/projects/update-pinned-answer-detail`, payload);
};
export const pinAnswersResponse = (payload: PinAnswerRequest) => {
  return axiosInstance.post(`api/projects/pin-answers`, payload);
};
export const shareAnswer = (payload: ShareAnswerRequest) => {
  return axiosInstance.post(`api/projects/share-pinned-answers`, payload);
};
export const getChatHistory = async (...args: any) => {
  let url = `api/projects/chat-history?`;

  args.forEach((x: any) => {
    if (x) {
      for (const [key, value] of Object.entries(x)) {
        if (value !== null && value !== "") url = url + `&${key}=${value}`;
      }
    }
  });

  return axiosInstance.get(url);
};
export const sendMessage = (payload: SendMessageRequest) => {
  return axiosInstance.post(`api/projects/prompt`, payload);
};
export const refreshPrompt = (payload: RefreshPromptRequest) => {
  return axiosInstance.post(`api/projects/refresh-prompt`, payload);
};

export const getChatHistoryInactiveAnswers = async (projectId: string) => {
  return axiosInstance.get(`api/projects/chat-inactive-answers?projectId=${projectId}`);
}
